"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
var core_1 = require("@emotion/core");
var styled_1 = __importDefault(require("@emotion/styled"));
var React = __importStar(require("react"));
var theme_1 = require("../theme");
var variations = {
    primary: {
        textColor: theme_1.theme.colors.contentInverse,
        defaultBackground: theme_1.theme.colors.bgPrimary,
        hoverBackground: theme_1.theme.colors.bgPrimaryHovered,
        activeBackground: theme_1.theme.colors.bgPrimaryPressed,
    },
    secondary: {
        textColor: theme_1.theme.colors.contentPrimary,
        defaultBackground: theme_1.theme.colors.bgNeutralSubtle,
        hoverBackground: theme_1.theme.colors.bgNeutralSubtleHovered,
        activeBackground: theme_1.theme.colors.bgNeutralSubtlePressed,
    },
    success: {
        textColor: theme_1.theme.colors.contentInverse,
        defaultBackground: theme_1.theme.colors.green500,
        hoverBackground: theme_1.theme.colors.green600,
        activeBackground: theme_1.theme.colors.green700,
    },
    flat: {
        textColor: theme_1.theme.colors.contentPrimary,
        defaultBackground: 'transparent',
        hoverBackground: theme_1.theme.colors.bgScrimHovered,
        activeBackground: theme_1.theme.colors.bgScrimPressed,
    },
    dangerous: {
        textColor: theme_1.theme.colors.contentInverse,
        defaultBackground: theme_1.theme.colors.bgNegative,
        hoverBackground: theme_1.theme.colors.bgNegativeHovered,
        activeBackground: theme_1.theme.colors.bgNegativePressed,
    },
};
var DefaultButton = styled_1.default.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  /* Center label */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: ", " ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: 1.7142857143; /* 24 / 14 */\n  border-radius: ", ";\n  border: none;\n  /* Don't stretch (or shrink) inside flex parents. */\n  flex: auto 0 0;\n  &:hover:enabled {\n    cursor: pointer;\n  }\n  &:disabled {\n    opacity: ", ";\n    cursor: not-allowed;\n  }\n  &:focus {\n    outline: ", " solid ", ";\n    outline-offset: ", ";\n  }\n  ", "\n"], ["\n  /* Center label */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: ", " ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: 1.7142857143; /* 24 / 14 */\n  border-radius: ", ";\n  border: none;\n  /* Don't stretch (or shrink) inside flex parents. */\n  flex: auto 0 0;\n  &:hover:enabled {\n    cursor: pointer;\n  }\n  &:disabled {\n    opacity: ", ";\n    cursor: not-allowed;\n  }\n  &:focus {\n    outline: ", " solid ", ";\n    outline-offset: ", ";\n  }\n  ", "\n"])), theme_1.theme.space.space8, theme_1.theme.space.space16, theme_1.theme.fontSizes.fontsize14, theme_1.theme.fontWeights.medium, theme_1.theme.radii.rounded, theme_1.theme.opacity.semiOpaque, theme_1.theme.borderWidths.thick, theme_1.theme.colors.borderPrimary, theme_1.theme.space.space2, function (_a) {
    var _b = _a.variation, variation = _b === void 0 ? 'primary' : _b;
    var _c = variations[variation], textColor = _c.textColor, defaultBackground = _c.defaultBackground, hoverBackground = _c.hoverBackground, activeBackground = _c.activeBackground;
    return (0, core_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      color: ", ";\n      background-color: ", ";\n      :hover:enabled {\n        background-color: ", ";\n      }\n      :active {\n        background-color: ", ";\n      }\n    "], ["\n      color: ", ";\n      background-color: ", ";\n      :hover:enabled {\n        background-color: ", ";\n      }\n      :active {\n        background-color: ", ";\n      }\n    "])), textColor, defaultBackground, hoverBackground, activeBackground);
});
/**
 * We don't want to inherit the behavior of buttons that take up the parent container's size.
 */
var LinkAsButton = (0, styled_1.default)(DefaultButton.withComponent('a'))(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: inline-flex;\n  cursor: pointer;\n  text-decoration: none;\n"], ["\n  display: inline-flex;\n  cursor: pointer;\n  text-decoration: none;\n"])));
exports.Button = React.forwardRef(function (props, ref) {
    return props.href ? (React.createElement(LinkAsButton, __assign({}, props, { ref: ref }))) : (React.createElement(DefaultButton, __assign({}, props, { ref: ref })));
});
exports.Button.defaultProps = {
    __type: 'Button',
    variation: 'primary',
};
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map